<template>
    <div class="modal fade" id="modal_add_income" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestIncome" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('views.clients.income.add') }}

                    </h5>
                    <button @click="closeModal('modal_add_income', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestIncome">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class="row">
                            <div class="col-md-12">
                                <checkboxInput :text="i18n.t('tables.income.customer.memberClub')"
                                    v-model="isMemberClub" name="isMemberClub" id="isMemberClub" />
                            </div>
                        </div>
                        <div v-if="isMemberClub" class="row">
                            <div class="col-md-12">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestIncome.memberMatricule"
                                        :label="i18n.t('tables.members.matricule')" :v="v$.memberMatricule"
                                        :disabled="false" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestIncome.memberName" :label="i18n.t('tables.income.name')"
                                        :v="v$.memberName" :disabled="false" />
                                    <!-- :disabled="isMemberClub" -->
                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.income.category_name')" :trackby="`id`"
                                        :label="`name`" :valueProp="`id`" v-model="requestIncome.income_category_id"
                                        :placeholder="`Dossiers`" :arrayOptions="categoriesList" refs="subscriptions"
                                        :v="v$.income_category_id" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.income.service_name')" :trackby="`id`"
                                        :label="`name`" :valueProp="`id`" v-model="requestIncome.income_service_id"
                                        :placeholder="`Dossiers`"
                                        :arrayOptions="servicesList?.filter((s) => s?.income_category_id === requestIncome?.income_category_id)"
                                        refs="subscriptions" :v="v$.income_service_id" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">

                                    <price-input v-model="requestIncome.total_amount"
                                        :label="i18n.t('tables.income.total_amount')" :v="v$.total_amount"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestIncome.date" :label="i18n.t('tables.income.date')"
                                        :v="v$.date" :disabled="false" :fixedDays="1" :isFixedDays="true" />
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group mr-b-0em">
                                    <inputTextarea v-model="requestIncome.description"
                                        :label="i18n.t('tables.income.description')" :v="v$.description"
                                        :disabled="false" />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 mb-2">
                            <div class="col-md-12">
                                <checkboxInput :text="i18n.t('views.clients.new_subscriptions.payment.want_to_pay')"
                                    v-model="selectedPayment" name="selectedPayment" id="selectedPayment" />
                            </div>
                        </div>
                        <div v-if="selectedPayment" class="row">
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestIncome.payment.paymentDate"
                                        :label="i18n.t('tables.payment.paymentDate')" :v="v$.payment.paymentDate"
                                        :disabled="false" :fixedDays="1" :isFixedDays="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.paymentMethod')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestIncome.payment.paymentMethod"
                                    :placeholder="i18n.t('tables.payment.paymentMethod')"
                                    :arrayOptions="payment_methodsList" refs="paymentMethod"
                                    :v="v$.payment.paymentMethod" />
                            </div>
                            <div v-if="requestIncome.payment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.bankName')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestIncome.payment.bankName"
                                    :placeholder="i18n.t('tables.payment.bankName')" :arrayOptions="bank_namesList"
                                    refs="bankName" :v="v$.payment.bankName" />
                            </div>

                            <div v-if="requestIncome.payment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestIncome.payment.chequeName"
                                        :label="i18n.t('tables.payment.chequeName')" :v="v$.payment.chequeName"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div v-if="requestIncome.payment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestIncome.payment.chequeNum"
                                        :label="i18n.t('tables.payment.chequeNum')" :v="v$.payment.chequeNum"
                                        :disabled="false" />
                                </div>
                            </div>

                            <div v-if="requestIncome.payment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestIncome.payment.dueDate"
                                        :label="i18n.t('tables.payment.dueDate')" :v="v$.payment.dueDate"
                                        :disabled="false" :fixedDays="1" :isFixedDays="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <price-input v-model="requestIncome.total_amount"
                                        :label="i18n.t('tables.income.total_amount')" :v="v$.total_amount"
                                        :disabled="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <price-input v-model="requestIncome.payment.amount_paid"
                                        :label="i18n.t('tables.payment.amount_paid')" :v="v$.payment.amount_paid"
                                        :disabled="false" />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-right">
                            <button type="submit" class="btn btn-primary mr-2">

                                {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                            </button>
                            <button type="button" @click="emptyState()" class="btn btn-cancel">

                                {{ i18n.t('button.cancel') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, reactive } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import checkboxInput from "@/components/inputsValidation/checkboxInput.vue";
import inputTextarea from "@/components/inputsValidation/ReusableTextarea.vue";



/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, numeric, minLength, minValue, helpers, requiredIf } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import dayjs from 'dayjs';

/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { useIncomeCategory } from "@/composables/income/useIncomeCategory";
import { useIncomeService } from "@/composables/income/useIncomeService";
import { useIncome } from "@/composables/income/useIncome";
import { incomesServices, clubUUID, incomesCategories, bank_names, payment_methods } from "@/shared/state";
import { IncomeRequest } from "@/interfaces/income";

export default defineComponent({
    components: { inputText, SingleSelect, checkboxInput, inputTextarea },
    name: "SomeComponent",
    setup() {
        const action = ref('add')
        const selectedPayment = ref(false)
        const isMemberClub = ref(false)

        const requestIncome = ref<IncomeRequest>({
            memberName: null,
            description: null,
            total_amount: null,
            income_category_id: null,
            income_service_id: null,
            date: dayjs(new Date()).format('YYYY-MM-DD'),
            memberMatricule: null,
            clubUUID: clubUUID.value,
            payment: {
                id: null,
                amount_paid: null,
                paymentMethod: null,
                bankName: null,
                chequeName: null,
                chequeNum: null,
                dueDate: null,
                paymentDate: dayjs(new Date()).format('YYYY-MM-DD'),
                status: "paid",
                pack_id: null, //subscription_details?.value?.pack_id,
                subscription_id: null, // subscription_details?.value?.subscription_id,
                member_subscription_id: null, // subscription_details?.value?.id,
                clubUUID: clubUUID.value,
                memberUUID: null,
                reference_id: null,
                reference_type: "services"
            }

        });

        const servicesList = computed(() => incomesServices.data);
        const categoriesList = computed(() => incomesCategories.data);
        const bank_namesList = computed(() => bank_names.value);
        const payment_methodsList = computed(() => payment_methods.value);
        const { closeModal } = useModal();

        const { addIncome, editIncome, isRequestIncome, errorIncome } = useIncome();


        // Validation 
        const rules = {

            memberName: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                String,
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                ),
            },
            description: {
                String
            },
            total_amount: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                numeric
            },
            income_category_id: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                numeric
            },
            income_service_id: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                numeric
            },
            date: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                String
            },

            clubUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                String
            },
            payment: {
                clubUUID: {
                    required: helpers.withMessage(i18n.t("validation.required"), required)
                },

                paymentMethod: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => selectedPayment.value))
                },
                paymentDate: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => selectedPayment.value))
                },
                bankName: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestIncome?.value?.payment?.paymentMethod === 'Chèque bancaire'))
                },
                chequeName: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestIncome?.value?.payment?.paymentMethod === 'Chèque bancaire'))
                },
                chequeNum: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestIncome?.value?.payment?.paymentMethod === 'Chèque bancaire'))
                },
                dueDate: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestIncome?.value?.payment?.paymentMethod === 'Chèque bancaire')),
                },

                amount_paid: {
                    requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestIncome?.value?.payment?.paymentMethod !== null)),
                    numeric,
                    paidAmountValid: helpers.withMessage(
                        i18n.t("validation.amountExceededError"),
                        (value) => {
                            const numberValue = Number(value);
                            const total_amount = totalAmount.value || 0
                            return numberValue !== null && numberValue <= total_amount;
                        }
                    )

                }

            }

        };
        const v$ = useVuelidate(rules, requestIncome, { $scope: 'icomes' });

        /**
         * Add or edit Service
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    await addIncome(requestIncome.value);
                    if (!errorIncome.value)
                        emptyState()

                } else {
                    Swal.fire({
                        title: i18n.t("message.confirmation.edit.title"),
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: i18n.t("button.edit"),
                        cancelButtonText: i18n.t("button.cancel"),
                        allowOutsideClick: false,   // ✅ disable closing by clicking outside
                  allowEscapeKey: false       // (optional) disable closing with ESC
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            await editIncome(requestIncome.value);
                            if (!errorIncome.value)
                                emptyState()
                        }
                    });
                }
            }
        }


        const emptyState = () => {
            action.value = 'add';
            requestIncome.value.id = null
            requestIncome.value.memberName = null
            requestIncome.value.description = null
            requestIncome.value.total_amount = null
            requestIncome.value.income_category_id = null
            requestIncome.value.income_service_id = null
            requestIncome.value.date = dayjs(new Date()).format('YYYY-MM-DD')
            requestIncome.value.memberMatricule = null
            requestIncome.value.clubUUID = clubUUID.value

            requestIncome.value.payment.bankName = null
            requestIncome.value.payment.chequeName = null
            requestIncome.value.payment.chequeNum = null
            requestIncome.value.payment.amount_paid = null
            requestIncome.value.payment.dueDate = null
            requestIncome.value.payment.paymentMethod = null
            requestIncome.value.payment.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            v$.value.$reset();
            closeModal('modal_add_income', 'add')
        };


        watch(() => isMemberClub.value, (newValue) => {
            requestIncome.value.memberName = null
        });

        watch(() => selectedPayment.value, (newValue) => {
            requestIncome.value.payment.bankName = null
            requestIncome.value.payment.chequeName = null
            requestIncome.value.payment.chequeNum = null
            requestIncome.value.payment.amount_paid = null
            requestIncome.value.payment.dueDate = null
            requestIncome.value.payment.paymentMethod = null
            requestIncome.value.payment.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
        });

        const selectedService = computed(() => servicesList.value?.find((s) => s?.id == requestIncome.value?.income_service_id))

        watch(() => selectedService.value, (newValue) => {
            requestIncome.value.total_amount = selectedService?.value?.amount || 0
        });

        const totalAmount = computed(
            () => {
                return requestIncome?.value?.total_amount;
            }
        )


        return {
            requestIncome,
            submitForm,
            emptyState,
            action,
            v$,
            i18n,
            categoriesList,
            servicesList,
            selectedPayment,
            bank_namesList,
            payment_methodsList,
            selectedService,
            closeModal,
            isMemberClub,
            isRequestIncome
        };
    },
});
</script>
